// Shared helpers between the DrinkActivity proto's google.protobuf.Timestamp and plain JS Dates.
// Mirrors the manual seconds/nanos construction Saufdings' own frontend uses
// (saufdingsfrontend/saufi/src/services/drinks/utils/timestamp.ts) rather than relying on
// Timestamp.fromDate/toDate, so both apps build the wire value the same way.
import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';

export function dateToTimestamp(date: Date): Timestamp {
  const timestamp = new Timestamp();
  timestamp.setSeconds(Math.floor(date.getTime() / 1000));
  timestamp.setNanos((date.getTime() % 1000) * 1_000_000);
  return timestamp;
}
